<template>
    <div>
        <div class="snow"></div>
        <div class="sky"></div>
    </div>
</template>

<script>
    export default {
        name: "Snow",
        data() {
            return {
                buttonStyle: 'background-color: #2c3e50'
            }
        },
    }
</script>

<style scoped>
    .sky {
        height: 50vh;
        background-color: #2c3e50;
        z-index: 5;
    }
    .snow {
        height: 20vh;
        width: 20vh;
        background-color: #ffffff;
        position: absolute;
        top: 45vh;
        left: 15vw;
        z-index: 10;
        transform: rotate(33deg) skew(-25deg);
        perspective: 250px;
    }
</style>